<template>
  <div class="page-error" id="page-error">
    <v-alert
    :title="status ? String(status) : 'Error'"
    :text="statusText"
    color="red" 
    :stacked="false"
    :color="'#fff'"
    variant="tonal"
    icon="mdi-alert"
    >
    </v-alert>
  </div>
</template>

<script setup>
  const props = defineProps([
    'status',
    'statusText'
  ])

  const statusText = ref('')

  onMounted(() => {
    if (props.status == 404) {
      statusText.value = 'Resource not found'
    } else if (props.statusText) {
      statusText.value = props.statusText
    } else {
      statusText.value = 'There was an error. Please try again.'
    }
  })
</script>